export default __webpack_public_path__ + "static/media/hht2_ep02_timeline_q03_b.b21c5c1a.png";